import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { authHeader } from "../../services/auth-header";
import { Link } from 'react-router-dom';
import { useNavigate, useParams } from "react-router-dom";
import { CSVLink } from 'react-csv';
import { BASE_URL } from '../../services/Api';
import { IoIosArrowBack, IoIosArrowForward, IoMdSearch } from 'react-icons/io';
import Swal from 'sweetalert2';
import "../Brand/BrandComponents.css"; 

export const ContactSTableComponets = ({ 
    head, 
    axiostabledata, 
    Edit, 
    View, 
    Add, 
    title, 
    Create, 
    Sumofkeys, 
    warehousehdata 
}) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { pointindex } = useParams();

    // States
    const [currentPage, setCurrentPage] = useState(1);
    const [searchInput, setSearchInput] = useState('');
    const [search, setSearch] = useState(encodeURIComponent(' '));
    const [number, setNumber] = useState([]);
    const [total, setTotal] = useState([]);
    const [size, setSize] = useState([]);
    const [getid, setGetid] = useState(0);
    const [limit, setLimit] = useState(10);
    const [sort1, setSort1] = useState(false);
    const [sort, setSort] = useState("asc");
    const [fieldnme, setFieldnme] = useState("id");
    const [data, setData] = useState([]);
    const [superid, setSuperid] = useState(0);
    const [exportpage, setExport] = useState([]);
    const [data1, setData1] = useState(10);
    const [entries, setEntries] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const count = [{ value: 10 }, { value: 20 }, { value: 30 }, { value: 50 }];

    // Debounced search
    useEffect(() => {
        const timer = setTimeout(() => {
            setSearch(encodeURIComponent(searchInput.trim() || " "));
            setCurrentPage(1);
            setGetid(0);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchInput]);

    // Fetch data
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(
                    `${BASE_URL}${axiostabledata}/${id}/${Number(currentPage) - 1}/${Number(limit)}/${sort}/${fieldnme}/${search}`,
                    { headers: authHeader() }
                );
                
                setEntries(response.data.Enteries);
                
                if (response.data.Index === undefined) {
                    setSize(0);
                    setNumber(0);
                    setData(response.data.data);
                } else {
                    setSize(response.data.Pages);
                    setNumber(response.data.Pages);
                    setData(response.data.Index);
                }
            } catch (error) {
                console.error(error);
                Swal.fire({
                    title: 'Error!',
                    text: 'Failed to fetch data',
                    icon: 'error'
                });
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [getid, limit, fieldnme, sort, currentPage, search]);

    // Calculate totals for footer
    const data5 = Object.assign(...Sumofkeys.map(({ first }) => ({
        [first]: data.reduce((acc, curr) => acc + (parseFloat(curr[first]) || 0), 0)
    })));

    // Handlers
    const pagination = (msg) => {
        setGetid(msg);
    };

    const handlechange = (entry) => {
        setData1(parseInt(entry));
        setLimit(parseInt(entry));
        setCurrentPage(1);
        setGetid(0);
    };

    const handlesort = (field) => {
        setSort1(!sort1);
        if (sort1) {
            setSort("asc");
            setFieldnme(field);
        } else {
            setSort("desc");
            setFieldnme(field);
        }
    };

    const handle = (id2) => {
        console.log(id2);
        if (id2 >= 0) {
            if (Number(pointindex) === 0) {
                navigate(`${Edit}/${id}/${id2.view}/${Number(currentPage)}`);
            } else {
                // Handle edit
            }
        } else {
            if (Number(pointindex) === 0) {
                navigate(`${View}/${id}/${id2.view}/${Number(currentPage)}`);
            } else {
                navigate(`${View}/${id}/${id2.view}/${currentPage}`);
            }
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        setSuperid(page - 1);
        pagination(page - 1);
    };

    const deleteHandler = async (itemId) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await axios.delete(
                    `${BASE_URL}${axiostabledata}/delete/${itemId}`,
                    { headers: authHeader() }
                );
                
                await Swal.fire({
                    title: 'Deleted!',
                    text: response.data.message || 'Item deleted successfully',
                    icon: 'success'
                });
                
                // Refresh data
                setGetid(getid + 1);
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text: error.response?.data?.message || 'Failed to delete item',
                    icon: 'error'
                });
            }
        }
    };

    // Back button handler
    const backHandler = () => {
        navigate(-1);
    };

    const renderPageNumbers = () => {
        const pages = [];
        const siblingsCount = 2;
        const firstPage = 1;
        const lastPage = number;
        let pageNumbers = [];

        const startPage = Math.max(firstPage, currentPage - siblingsCount);
        const endPage = Math.min(lastPage, currentPage + siblingsCount);

        if (startPage > firstPage + 1) {
            pageNumbers.push(
                <button key={firstPage} className="bc-page-btn" onClick={() => handlePageChange(firstPage)}>
                    {firstPage}
                </button>
            );
            pageNumbers.push(<span key="dots-start" className="bc-page-dots">...</span>);
        } else if (startPage > firstPage) {
            pageNumbers.push(
                <button key={firstPage} className="bc-page-btn" onClick={() => handlePageChange(firstPage)}>
                    {firstPage}
                </button>
            );
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    className={`bc-page-btn${i === currentPage ? ' bc-page-btn--active' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }

        if (endPage < lastPage - 1) {
            pageNumbers.push(<span key="dots-end" className="bc-page-dots">...</span>);
            pageNumbers.push(
                <button key={lastPage} className="bc-page-btn" onClick={() => handlePageChange(lastPage)}>
                    {lastPage}
                </button>
            );
        } else if (endPage < lastPage) {
            pageNumbers.push(
                <button key={lastPage} className="bc-page-btn" onClick={() => handlePageChange(lastPage)}>
                    {lastPage}
                </button>
            );
        }

        return pageNumbers;
    };

    const getShowingText = () => {
        const start = superid * data1 + 1;
        const end = Math.min(superid * data1 + data1, entries);
        return `Showing ${start} to ${end} of ${entries} entries`;
    };

    // Determine if footer should be shown
    const shouldShowFooter = ['brand/page', 'warehouse/page', 'product/page', 'purchase', 'pr', 'workorder', 'primaryworkorder', 'so', 'dc', 'sales', 'sr'].includes(axiostabledata);

    return (
        <div className="bc-card">
            {/* Header */}
            <div className="bc-card__header">
                <h6 className="bc-card__title">{title}</h6>
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <button onClick={backHandler} className="bc-add-btn" style={{ background: "linear-gradient(135deg, #6c757d, #5a6268)" }}>
                        🔙 Back
                    </button>
                    {Create.length !== 0 && (
                        <Link to={`/contactSCreate/${id}`}>
                            <button className="bc-add-btn">{Add}</button>
                        </Link>
                    )}
                    {exportpage.length !== 0 && (
                        <CSVLink className="bc-add-btn" data={exportpage} style={{ textDecoration: "none", display: "inline-flex" }}>
                            Export
                        </CSVLink>
                    )}
                </div>
            </div>

            {/* Body */}
            <div className="bc-card__body">
                {/* Controls */}
                <div className="bc-controls">
                    <div className="bc-entries">
                        <span className="bc-entries__label">Show entries:</span>
                        <select className="bc-entries__select" onChange={(e) => handlechange(e.target.value)} value={data1}>
                            {count.map((item) => (
                                <option key={item.value} value={item.value}>{item.value}</option>
                            ))}
                        </select>
                    </div>

                    {/* Single Search Field - Fixed duplicate issue */}
                    <div style={{ position: "relative" }}>
                        <IoMdSearch style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "var(--primary-500)", zIndex: 1 }} size="1.2em" />
                        <input
                            type="text"
                            placeholder="Search..."
                            className="bc-search"
                            style={{ paddingLeft: "35px", width: "220px" }}
                            onChange={(e) => setSearchInput(e.target.value)}
                            value={searchInput}
                        />
                    </div>
                </div>

                {/* Table */}
                <div className="bc-table-wrapper">
                    <table className="bc-table">
                        <thead>
                            <tr>
                                {head.map((headItem, index) => {
                                    const isAction = headItem.field === "action";
                                    const shouldHide = isAction && axiostabledata === "mininmumstock";
                                    
                                    return (
                                        <th
                                            key={index}
                                            className={`bc-th ${!isAction ? 'bc-th--sortable' : ''} ${fieldnme === (isAction ? "id" : headItem.field) ? 'bc-th--active' : ''}`}
                                            onClick={() => !isAction && handlesort(isAction ? "id" : headItem.field)}
                                            style={{ display: shouldHide ? "none" : "" }}
                                        >
                                            {headItem.label}
                                            {!isAction && fieldnme === (isAction ? "id" : headItem.field) && (
                                                <span className="bc-sort-icon">
                                                    {sort === 'asc' ? ' ↑' : ' ↓'}
                                                </span>
                                            )}
                                        </th>
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={head.length} className="bc-td bc-td--empty">
                                        Loading...
                                    </td>
                                </tr>
                            ) : data.length === 0 ? (
                                <tr>
                                    <td colSpan={head.length} className="bc-td bc-td--empty">
                                        No data found
                                    </td>
                                </tr>
                            ) : (
                                data.map((item, rowIndex) => (
                                    <tr key={rowIndex} className="bc-tr">
                                        {head.map((headItem, colIndex) => {
                                            const isAction = headItem.field === "action";
                                            const shouldHide = isAction && axiostabledata === "mininmumstock";
                                            
                                            return (
                                                <td
                                                    key={colIndex}
                                                    className="bc-td"
                                                    style={{ display: shouldHide ? "none" : "" }}
                                                    onClick={() => {
                                                        if (isAction) {
                                                            handle({ "view": item.id });
                                                        } else {
                                                            handle(item.id);
                                                        }
                                                    }}
                                                >
                                                    {isAction ? (
                                                        <div className="bc-actions">
                                                            <button
                                                                className="bc-action-btn bc-action-btn--view"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handle({ "view": item.id });
                                                                }}
                                                                title="View"
                                                            >
                                                                👁️
                                                            </button>
                                                            {Edit && (
                                                                <button
                                                                    className="bc-action-btn bc-action-btn--edit"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        navigate(`${Edit}/${id}/${item.id}/${currentPage}`);
                                                                    }}
                                                                    title="Edit"
                                                                >
                                                                    ✏️
                                                                </button>
                                                            )}
                                                            <button
                                                                className="bc-action-btn bc-action-btn--delete"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    deleteHandler(item.id);
                                                                }}
                                                                title="Delete"
                                                            >
                                                                🗑️
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <span className="bc-cell-text">
                                                            {item[headItem.field]}
                                                        </span>
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))
                            )}
                        </tbody>
                        {shouldShowFooter && data.length > 0 && (
                            <tfoot>
                                <tr>
                                    {head.map((headItem, index) => (
                                        <th key={index} className="bc-th">
                                            {data5.hasOwnProperty(headItem.field) ? data5[headItem.field].toFixed(2) : ''}
                                        </th>
                                    ))}
                                </tr>
                            </tfoot>
                        )}
                    </table>
                </div>

                {/* Pagination - Fixed with icons instead of text */}
                <div className="bc-pagination">
                    <span className="bc-pagination__info">
                        {getShowingText()}
                    </span>

                    <div className="bc-pagination__controls">
                        <button
                            className={`bc-nav-btn${currentPage === 1 ? ' bc-nav-btn--disabled' : ''}`}
                            onClick={() => handlePageChange(currentPage > 1 ? currentPage - 1 : 1)}
                            disabled={currentPage === 1}
                            title="Previous"
                        >
                            <IoIosArrowBack />
                        </button>

                        <div className="bc-pages">
                            {renderPageNumbers()}
                        </div>

                        <button
                            className={`bc-nav-btn${currentPage === number ? ' bc-nav-btn--disabled' : ''}`}
                            onClick={() => handlePageChange(currentPage === number ? number : currentPage + 1)}
                            disabled={currentPage === number}
                            title="Next"
                        >
                            <IoIosArrowForward />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};